const payResult = {
  path: 'payResult',
  component: resolve => require(['../../../../components/pages/signUp/payResult'], resolve)
}
export default payResult



// WEBPACK FOOTER //
// ./src/router/pages/signUp/payResult/index.js